import uc from "@/api/uc.js";
import store from '@/store/login';

const state = {
    currentUser: null,
    loginAccount: null
}

const getters = {}

const actions = {
    actionLoginAccount({ commit, state }, loginAccount){
        commit("mutationLoginAccount", loginAccount)
    },
    loginByPrincipal({ commit, state }, principal) {
        return new Promise((resolve, reject) => {
            uc.authentication(principal, user => {
                if(user){
                    //user.password = principal.password;
                    sessionStorage.setItem("password",principal.password);
                    sessionStorage.setItem("currentUser", JSON.stringify(user))
                    commit("setCurrentUser", user)
                    resolve(user.loginStatus)
                }
            }, (msg) => {
                commit("clearCurrentUser")
                reject(msg)
            })
        })
    },
    validAndCompletedCurrent({ commit, state }, token) {
        return new Promise((resolve, reject) => {
            if (state.currentUser && !token ) {
                resolve();
            }
            else {
                const user = sessionStorage.getItem("currentUser")
                if (user !="null" && user!=undefined && user!="" && !token) {
                    commit("setCurrentUser", JSON.parse(user))
                    resolve()
                }
                else if (token) {
                    uc.basicSso(token, user => {
                        //user.password = sessionStorage.getItem("password");
                        sessionStorage.setItem("password",sessionStorage.getItem("password"));
                        sessionStorage.setItem("currentUser", JSON.stringify(user));
                        commit("setCurrentUser", user);
                        resolve();
                    }, () => {
                        reject();
                    });
                }
                else {
                    reject()
                }
            }
        })
    },
    logoutAndCleanUp({ commit, state }) {
        return new Promise((resolve, reject) => {
            sessionStorage.removeItem("currentUser")
            commit("clearCurrentUser");
            commit("user/setCurrentUserDetail", null, { root: true });
            commit("user/setCurrentUserOrg", null, { root: true });
            resolve();
        })
    }
}

const mutations = {
    setCurrentUser(state, current) {
        state.currentUser = current
    },
    clearCurrentUser(state) {
        state.currentUser = null
    },
    mutationLoginAccount(state,loginAccount){
        state.loginAccount = loginAccount;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
